import { useState, useEffect, useRef } from "react";
import {
	Input,
	Form,
	Row,
	Col,
	// Checkbox,
	Button,
	Space,
	message,
	Spin,
	Alert,
} from "antd";
import { EyeInvisibleOutlined, EyeTwoTone } from "@ant-design/icons";
import "../../../styles/login.css";
import { fetchApi } from "../../../services/api";
import constants from "../../../constants/constants";
import { useHistory } from "react-router";
import Footer from "./../../../footer";
import Headers from "../../../header";
import Modal from "antd/lib/modal/Modal";
import Book from './Book';
import { useAuth } from '../../../globalFunctions/AuthContext';
import Loader from "./Loader";
const Login = () => {
	const { login, loading, user, cardData } = useAuth();
	const history = useHistory();
	const [loader, setLoading] = useState(false);
	const [isLoggedIn,setIsLoggedIn]=useState(false);
	const [userName,setUserName]=useState("");
	const [password,setPassword]=useState("");
	// const [rememberme,setRememberMe]=useState(false);
	const [isLoggedInModal,setIsLoggedInModal]=useState(false);
	const [form] = Form.useForm();
	const myRef = useRef();
	useEffect(() => {
		if (user !== null && user?.userId) {
			history.push("/home");
		}
		let queryString = window.location.href;
		var urlParam = queryString.substring(queryString.lastIndexOf('?') + 1);
		if(urlParam==="type=feedback"){
			sessionStorage.setItem("feedback","feedback");
		}
	}, [user, history]);
	useEffect(() =>{
		if(myRef && myRef.current){
			const { input } = myRef.current;
			input.focus();
		}
	});
	const handleUsername=(e)=>{
		setUserName(e.target.value);
	};
	const handlePassword=(e)=>{
		setPassword(e.target.value);
	};
	//Executes on click of login button
	const onFinish = () => {
		if(userName&&password){
			let agent = navigator.userAgent;
			setLoading(true);
			let payload = null;
			payload = {
				username: userName,
				password: password,
				remember_me: /* rememberme ? 1 :  */0,
				browser:agent,
			};
			if(isLoggedIn===true){
				payload.allow_login= 1;
			}
			fetchApi("/login", "post", payload)
				.then(async (res) => {
					setLoading(false);
					if (res && res.code && res.code === 200) {
						setIsLoggedIn(false);
						await login();
						let userIdFromMyProfile=sessionStorage.getItem("idFromMyProfile");
						if(userIdFromMyProfile){
							history.push("/myprofile");
						}else{
							history.push("/home");
						}
					} else {
						if(res&&res.message==="User already Logged-in"){
							setIsLoggedInModal(true);
							setIsLoggedIn(true);
						}else{
							message.error({
								content:res.message,
								duration:constants.MessageDisplayLong,
							});
						}
					}
				})
				.catch((err) => {
					setLoading(false);
					if(err?.code === 429){
						message.error({
							content:err.message,
							duration:constants.MessageDisplayLong,
						});
						return;
					}
					message.error("Failed to login");
				});
		}
	};
	if (loading) {
		return <Spin spinning={true} size="large" indicator={<Loader/>}></Spin>;
	}
	return (
		<div>
			<Headers/>
			{/* <Space style={{ 
				backgroundColor:"#eded87",
				whiteSpace:"nowrap"
			}}>
				<span style={{ 
					fontWeight:"bold" ,
					marginLeft:"20px",
					fontSize:"larger",
				}}>Important Notice :</span>
				<marquee  width="100%" direction="left" height="25px" style={{ 
					fontWeight:400,
					fontSize:"larger",
					paddingTop:"2px"
				}}>
					{constants.ImportantNotice}
				</marquee></Space> */}
			<div className="login-content flex-vertical-middle">
				<Row gutter={[{
					xs: 8,
					sm: 24,
					md: 48,
					lg: 8,
					xl: 8
				}, 8]} className="login-px">
					<Book/>
					<Col lg={24} xl={14} className="w-100 flex-middle">
						<div className="text-right signup-link">
							<Space>
								{constants.SignUpRedirect}
								<Button
									type="link"
									className="pl-0"
									onClick={() => {
										history.push("/registration");
									}}
									disabled={cardData?.type === 1}
								>
									{constants.SignUpRedirectLink}
								</Button>
							</Space>
						</div>
						<div className="login-col">
							<div className="ml-135">
								{(cardData?.type === 1 || cardData?.type === 2) && (
									<div className="d-none maintain-txt login-form mb-4">
										<Alert
											description={<div dangerouslySetInnerHTML={{ __html: cardData?.message }}/>}
											type={cardData.type === 1 ? "error" : "warning"}
											className="alert-box"
										/>
									</div>
								)}
								<h1>{constants.LoginHeader}</h1>
								<Form layout="vertical" form={form} onFinish={onFinish} autoComplete="off">
									<div className="login-form">
										<Form.Item
											label={constants.Username}
											name="userName"
											rules={[
												{
													required: true,
													message: constants.LoginUserNameValid,
												},
											]}
										>
											<Input autoFocus className="login-input" placeholder={constants.Username} onChange={handleUsername}/>
										</Form.Item>
										<Form.Item
											label={constants.Password}
											name="password"
											rules={[
												{
													required: true,
													message: constants.LoginPasswordValid,
												},
											]}
										>
											<Input.Password
												className="login-input"
												placeholder={constants.Password}
												iconRender={(visible) =>
													visible ? <EyeTwoTone/> : <EyeInvisibleOutlined/>
												}
												onChange={handlePassword}
											/>
										</Form.Item>
										<Row>
											{/* <Col span={12}>
												<Form.Item className="test-options">
													<Checkbox checked={rememberme} onChange={(e)=>setRememberMe(e.target.checked)}>{constants.RememberMe}</Checkbox>
												</Form.Item>
											</Col> */}
											<Col span={24} className="text-right">
												<Form.Item>
													<Button
														type="link"
														className="pr-0"
														onClick={() => {
															history.push("/forgot-password");
														}}
														disabled={cardData?.type === 1}
													> 
														{constants.ForgotPsdRedirectLink}
													</Button>
												</Form.Item>
											</Col>
										</Row>
									</div>
									<Form.Item>
										<Button
											shape="round"
											className="gold-btn login-btn"
											// type="button"
											htmlType="submit"
											loading={loader}
											// onClick={()=>{onFinish();}}
											// href="/"
											disabled={cardData?.type === 1}
										>
											{constants.LoginBTN}
										</Button>
									</Form.Item>
								</Form>
								<div className="text-center">
									<Space>
										{constants.EmailRedirect}
										<Button
											type="link"
											className="pl-0"
											onClick={() => {
												history.push("/resend-email");
											}}
											disabled={cardData?.type === 1}
										>
											{constants.ResendLink}
										</Button>
									</Space>
								</div>
							</div>
						</div>
					</Col>
				</Row>
			</div>
			<Footer/>
			<Modal
				title="Login"
				visible={isLoggedInModal}
				width={510}
				onCancel={()=>{setIsLoggedInModal(false);}}
				className="already-logged-modal"
				footer={[
					<Input
						ref={myRef}
						key="submit"
						type="button" 
						value="Use Here"
						className="input-btn-purple mt-2" 
						htmlType="submit"
						onClick={()=>{onFinish();}}
					/>,
					<Button key="close" onClick={()=>{setIsLoggedInModal(false);}} className="mt-2">
						{constants.CancelBTN}
					</Button>
				]}
			>
				<p>{constants.LoginRestriction}</p>
				<p>{constants.LoginRestrictionPart2}</p>
			</Modal>
		</div>
	);
};
export default Login;
